import React from 'react';
import { useAtnaConversation } from '../../hooks/useAtnaConversation';
import { AtnaDialogShell } from '../atna/AtnaDialogShell';
import { AtnaMessage } from './AtnaMessage';
import type { AtnaTurnKind } from '../../types/demandes';
interface AtnaConversationDialogProps {
  initialText: string;
  onClose: () => void;
  /** Shared layout id: the launcher pill morphs into this panel. */
  layoutId: string;
}
export function AtnaConversationDialog({
  initialText,
  onClose,
  layoutId
}: AtnaConversationDialogProps) {
  const {
    turns,
    thinking,
    draft,
    setDraft,
    submitDraft,
    description,
    intent,
    setIntent,
    setAddress,
    address,
    answer,
    setAnswer,
    hasPhoto,
    attachPhoto,
    exchange,
    detect,
    liveAtnaId,
    lastAtnaKind
  } = useAtnaConversation(initialText);
  return <AtnaDialogShell layoutId={layoutId} subtitle="Signaler un problème" onClose={onClose} turns={turns} thinking={thinking} liveAtnaId={liveAtnaId} footnote="ATNA peut se tromper. Vérifiez le résumé avant d’envoyer votre demande." prompt={{
    value: draft,
    onChange: setDraft,
    onSubmit: submitDraft,
    onAddPhoto: attachPhoto,
    photoAttached: hasPhoto,
    placeholder: lastAtnaKind === 'succes' ? 'Autre chose à signaler ?' : 'Répondre à ATNA, ou préciser votre demande…'
  }} renderAtna={(kind, live) => <AtnaMessage kind={kind as AtnaTurnKind} live={live} intent={intent} address={address} description={description} answer={answer} hasPhoto={hasPhoto} onConfirmIntent={() => exchange('Oui, c’est bien ça', 'lieu')} onPickIntent={setIntent} onNotEmergency={() => {
    setIntent(detect(description));
    exchange('Ce n’est pas une urgence', 'comprehension');
  }} onPickAddress={(picked, source) => {
    setAddress(picked);
    exchange(source === 'position' ? `Ma position : ${picked}` : picked, hasPhoto ? 'detail' : 'photo');
  }} onAddPhoto={attachPhoto} onSkipPhoto={() => exchange('Continuer sans photo', 'detail')} onAnswer={option => {
    setAnswer(option);
    exchange(option, 'revue');
  }} onSend={() => exchange('Envoyer ma demande', 'succes')} onEdit={() => exchange('Je veux modifier ma demande', 'comprehension')} onReset={onClose} data-id="element-842" data-mp="1r6dicy9gyh1o" />} data-id="element-841" data-mp="2z1uoitbjadow" />;
}